import { useCallback, useState } from "react";
import { FiX } from "react-icons/fi";
import { MdRefresh } from "react-icons/md";

import { Button } from "~/components/Button";
import { Modal } from "~/components/Modal";
import { insertToast } from "~/modules/toasts/services";
import { api } from "~/utils/api";

type Props = {
	chargeId: string;
};

export const RetryChargeButton: React.FC<Props> = ({ chargeId }) => {
	const [showModal, setShowModal] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(false);

	const handleShowModal = useCallback(() => {
		setShowModal(true);
	}, []);

	const handleCloseModal = useCallback(() => {
		setShowModal(false);
	}, []);

	const handleRetryCharge = useCallback(async () => {
		setLoading(true);
		setShowModal(false);
		await api
			.post(`/admin/sales/charges/${chargeId}/retry`)
			.then(({ data }) => {
				data &&
					insertToast({
						type: "success",
						message: "Cobrança reenviada com sucesso",
						duration: 4,
					});
			})
			.catch((error) => {
				insertToast({
					type: "error",
					message: error.response?.data?.message || "Erro ao reenviar cobrança",
					duration: 4,
				});
			})
			.finally(() => {
				setLoading(false);
			});
	}, [chargeId]);

	return (
		<>
			<button
				onClick={handleShowModal}
				disabled={loading}
				className="bg-slate-200 hover:bg-slate-300 flex justify-center
          items-center rounded-full h-8 w-8 disabled:opacity-50"
			>
				<MdRefresh
					data-loading={loading}
					size={22}
					className="data-[loading=true]:animate-spin text-gpa-blue-500"
				/>
			</button>
			<Modal visible={showModal}>
				<div className="flex flex-col">
					<div className="flex items-center justify-between mb-2">
						<h2 className="text-xl font-medium truncate">Reenviar cobrança</h2>
						<button
							className="bg-white hover:bg-gpa-gray-50 p-1.5 rounded-full"
							onClick={handleCloseModal}
						>
							<FiX size={24} />
						</button>
					</div>

					<p className="my-6">Confirme o re-envio desta cobrança</p>

					<div className="flex self-end gap-4">
						<Button onClick={handleRetryCharge}>Confirmar</Button>
						<Button mode="outlined" onClick={handleCloseModal}>
							Cancelar
						</Button>
					</div>
				</div>
			</Modal>
		</>
	);
};
